<template>
    <div class="sustainability-r">
        <p class="indent">Въпреки своята преобладаващо експортна ориентираност Алкомет остава тясно свързан и с развитието на българската икономика и българското общество. Част от целите на компанията по отношение на корпоративната социална отговорност са повишаване на заетостта сред местното население, ефективно подпомагане на образователни, медицински, културни, социални и други институции, подкрепа на благотворителни и дарителски организации. През 2025 г., за поредна година, компанията бе удостоена с приза „Дарител на годината” от Община Шумен.  </p>

      <p>
        <a href="/static/files/responsibility/Политика-за-надлежна-проверка-основана-на-риска.pdf" target="_blank">Политика за надлежна проверка, основана на риска, при
          доставкa на първичен алуминий – Избягване на райони,
          засегнати от конфликти и високорискови райони
          (CAHRAs)</a>
      </p>
      <p>
        <a href="/static/files/responsibility/Политика-за-отговорно-снабдяване.pdf" target="_blank">Политика за отговорно снабдяване</a>
      </p>

      <p>
        <a href="/static/files/sustainability/Sustainability-policy-2025_bg.pdf" target="_blank">Политика по Устойчиво Развитие</a>
      </p>
      <p><a href="/static/files/sustainability/алкомет-политика-за-социална-отговорност.pdf" target="_blank">Политика за социална отговорност</a></p>
      <p><a href="/static/files/Правилник_за_бизнес_поведение_и_етика.pdf" target="_blank">Правилник за бизнес поведение и етика</a></p>
        <p><a href="/static/files/suppliers-code-of-conduct-bg.pdf" target="_blank">Кодекс на поведение за доставчици</a></p>
      <p><a href="/static/files/Процедура-за-борба-с-подкупите-и-корупцията_102020.pdf" target="_blank">Процедура за борба с подкупите и корупцията</a></p>
      <p><a href="/static/files/Процедура-за-управление-на-жалби_102020.pdf" target="_blank">Процедура за управление на жалби</a></p>
      <p class="otp-left"><a href="https://forms.gle/7jp7Qks8z4hKNk7R6" target="_blank"><i class="arrow"></i>Форма за подаване на жалба / сигнал / предложение  </a></p>
      <p><a href="/static/files/Alcomet_action_plan_2511261.pdf" target="_blank">План за действие за намаляване на емисиите на парникови газове </a></p>
      <p><a href="/static/files/MODERN_SLAVERY_BG.pdf" target="_blank">Годишна декларация относно забраната на принудителния труд и съвременното робство във всичките му форми </a></p>
      <!--
      <p><a href="/static/files/Policy-b-Anti-bribery-and-corruption.pdf" target="_blank">Политика за борба с подкупите и корупцията</a></p>
      <p><a href="/static/files/Policy-b-Complaint-management.pdf" target="_blank">Политика за управление на жалби</a></p>
      <p><a href="/static/files/Policy-Code-of-conduct.pdf" target="_blank">Кодекс на поведение</a></p>
      <p><a href="/static/files/Policy_Soc-Resp.pdf" target="_blank">Политика социална отговорност</a></p>
      <p><a href="/static/files/A-POLICY-REGARDING-CHILD-LABOUR-1.pdf" target="_blank">Политика детски труд</a></p>
        -->
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-r .otp-left { padding-left:50px;}
.sustainability-r .otp-left .arrow {
    border: solid ;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-right:15px;
}


.sustainability-r > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-r {
    padding-bottom: 20px;
  }
  .sustainability-r > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Responsibility.vue